// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        header: $('header'),
        current_position: 0,

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Handle notification bar
         */
        __handleNotificationBar: function() {
            const notification_bar = wntrTheme.body.find('#notification-bar');

            if(notification_bar.length > 0 && window.localStorage) {
                // Ensure user hasn't already seen this notification_bar
                const slug = 'notification_bar_' + notification_bar.data('slug');
                const notification_bar_seen = localStorage.getItem(slug);

                wntrTheme.body.find('.notification-bar__close').on('click', function() {
                    localStorage.setItem(slug, true);
                    notification_bar.fadeOut('fast', function() {
                        wntrTheme.body.removeClass('has-notification-bar');
                        $(this).remove();
                    });
                });

                if(notification_bar_seen === 'true') {
                    notification_bar.remove();
                    wntrTheme.body.removeClass('has-notification-bar');
                } else {
                    notification_bar.addClass('is-visible');
                }

                if($(window).width() < 1009) {
                    const $notification_bar_height = wntrTheme.body.find('#notification-bar').outerHeight();
                    wntrTheme.body.find('header').css('top', $notification_bar_height);
                }
            }
        },

        /**
         * Generate sidebar anchor link
         */
        __genererateSidebarAnchorLinks: function() {
            const $sidebar = wntrTheme.body.find('.block__sidebar-self-generated');
            const accepted_tags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

            if($sidebar.length > 0) {
                const anchor_links = [];
                $('main > .inner [id]').each(function() {
                    const tag = $(this).prop('tagName');

                    if(accepted_tags.includes(tag)) {
                        anchor_links.push({
                            'title': $(this).text(),
                            'id': $(this).attr('id')
                        });
                    }
                });

                $sidebar.find('.block__sidebar-spinner').remove();

                anchor_links.forEach(function(tag) {
                    $sidebar.find('ul').append('<li><a href="#' + tag.id + '">' + tag.title + '</a></li>');
                });

                if($(window).width() >= 1009) {
                    wntrTheme.body.find('.block__sidebar').closest('.wp-block-column').css('margin-left', '6rem');
                }
            }

            wntrTheme.body.on('click', '.block__sidebar-self-generated a', function(e) {
                e.preventDefault();

                $('html, body').animate({
                    scrollTop: $($(this).attr('href')).offset().top - 25
                }, 500);
            });
        },

        /**
         * Toggle form tabs
         */
        __toggleFormTabs: function() {
            const $form_tab = wntrTheme.body.find('.block__form-tab');

            $form_tab.on('click', function() {
                wntrTheme.body.find('.block__form-tab').removeClass('is-active');
                wntrTheme.body.find('.block__form').removeClass('is-active');

                $(this).addClass('is-active');
                wntrTheme.body.find('.block__form[data-form=' + $(this).data('tab') + ']').addClass('is-active');
            });
        },

        /**
         * Toggle search page tabs
         */
        __toggleSearchPageTabs: function() {
            const $search_tab = wntrTheme.body.find('.search__results-tab');

            $search_tab.on('click', function() {
                wntrTheme.body.find('.search__results-tab').removeClass('is-active');
                wntrTheme.body.find('.search__result').removeClass('is-active');

                $(this).addClass('is-active');
                wntrTheme.body.find('.search__result--' + $(this).data('tab')).addClass('is-active');
            });
        },

        /**
         * Toggle primary (header) menu
         */
        __togglePrimaryMenu: function() {
            const $serch_form_input = wntrTheme.body.find('.search-form .search-field');
            const $sub_menu = wntrTheme.body.find('.header-nav__sub-menu');
            const $toggle_sub_menu_btn = wntrTheme.body.find('.header-nav__toggle-sub-menu');
            const $toggle_search_menu_btn = wntrTheme.body.find('.header-top__toggle-search');
            const $toggle_mobile_menu_btn = wntrTheme.body.find('.header-top__toggle-menu .hamburger');
            const $toggle_languages_menu_btn = wntrTheme.body.find('.header__nav-language-toggle-btn');

            // Toggle languagues
            $toggle_languages_menu_btn.on('click', function() {
                $(this).closest('.header-nav__languages').toggleClass('is-active');
            });

            // Mobile toggle
            $toggle_mobile_menu_btn.on('click', function() {
                $(this).toggleClass('is-active');
                wntrTheme.header.toggleClass('is-active');
                wntrTheme.body.toggleClass('header--is-active');

                if(wntrTheme.body.hasClass('has-notification-bar')) {
                    if($(window).width() < 1009 && wntrTheme.body.hasClass('header--is-active')) {
                        wntrTheme.body.find('header').css('top', '0');
                    } else {
                        const $notification_bar_height = wntrTheme.body.find('#notification-bar').outerHeight();
                        wntrTheme.body.find('header').css('top', $notification_bar_height);
                    }
                }


                if(wntrTheme.body.hasClass('header--is-active')) {
                    if($(window).width() < 1009) {
                        wntrTheme.current_position = wntrTheme.document.scrollTop();
                    }

                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                } else {
                    wntrTheme.body.removeClass('body--fixed');

                    if($(window).width() < 1009) {
                        wntrTheme.document.scrollTop(wntrTheme.current_position);
                    }
                }
            });

            $toggle_sub_menu_btn.on('click', function(e) {
                if($(window).width() < 1009) {
                    e.preventDefault();
                    $(this).toggleClass('is-active');
                }
            });

            $toggle_search_menu_btn.on('click', function() {
                wntrTheme.header.toggleClass('search--is-active');
                wntrTheme.body.toggleClass('search--is-active');

                if(wntrTheme.body.hasClass('has-notification-bar')) {
                    if($(window).width() < 1009 && wntrTheme.body.hasClass('search--is-active')) {
                        wntrTheme.body.find('header').css('top', '0');
                    } else {
                        const $notification_bar_height = wntrTheme.body.find('#notification-bar').outerHeight();
                        wntrTheme.body.find('header').css('top', $notification_bar_height);
                    }
                }

                if(wntrTheme.header.hasClass('search--is-active')) {
                    $serch_form_input.focus();
                } else {
                    $serch_form_input.blur();
                }
            });

            // Desktop toggle
            $toggle_sub_menu_btn.on('mouseover', function() {
                $(this).addClass('is-hover-active');

                const $sub_menu = $(this).closest('.header-nav__item').find('.header-nav__sub-menu');
                const $header_menu = $(this).closest('.header-nav__wrapper');
                $sub_menu.css('top', $header_menu.height());
            });

            $toggle_sub_menu_btn.on('mouseout', function() {
                $(this).removeClass('is-hover-active');
            });

            $sub_menu.on('mouseover', function() {
                $(this).closest('.header-nav__item').find('.header-nav__toggle-sub-menu').addClass('is-hover-active');
            });

            $sub_menu.on('mouseout', function() {
                $(this).closest('.header-nav__item').find('.header-nav__toggle-sub-menu').removeClass('is-hover-active');
            });

            let resize_timeout = null;
            const resize_throttle = 50;
            $(window).on('resize', function() {
                if(!resize_timeout) {
                    resize_timeout = setTimeout(function() {
                        if($(window).width() >= 1009) {
                            $toggle_sub_menu_btn.removeClass('is-active');
                        }

                        resize_timeout = null;
                    }, resize_throttle);
                }
            });

            // Hide on ESC
            $(document).on('keyup', function(e) {
                if(e.key === "Escape") {
                    wntrTheme.body.find('.header-nav__languages').removeClass('is-active');
                }
            });
        },

        /**
         * NavXT Breascrumbs translations
         */
        __navxtBreadcrumbTranslations: function() {
            if(wntrTheme.body.find('.breadcrumbs__wrapper').length > 0) {
                const $breadcrumbs = wntrTheme.body.find('.breadcrumbs__wrapper span[property="name"]');

                if($('html').attr('lang') === 'sv-SE' && $breadcrumbs.length > 0) {
                    $.each($breadcrumbs, function() {
                        const $breadcrumb = $(this);

                        if($breadcrumb.text().toLowerCase() === 'posts') {
                            $breadcrumb.text('Artiklar');
                        }
                    });
                }
            }
        },

        /**
         * Wrap post meta in column block if column block are last of type
         */
        __wrapPostMetaInCloumnBlock: function() {
            const $single_post_blocks = $('.single-post main .inner:not(:empty)');
            const num_blocks = $single_post_blocks.length;
            let $last_column_block = null;

            // Check if the last inner is a column
            if($single_post_blocks.length > 0) {
                $single_post_blocks.each(function(index) {
                    const $inner = $(this);
                    if(index === (num_blocks - 1) && $inner.find('>:first-child').hasClass('wp-block-columns')) {
                        $last_column_block = $inner.find('>:first-child');
                    }
                });
            }

            // If last block is a column, wrap the meta and further reading in a column block
            if($last_column_block) {
                // Support up to 6 columns
                const $column_flex_basis = [];
                let column_with_content_index = null;
                for(let i = 1; i <= 6; i++) {
                    if($last_column_block.find('>:nth-child(' + i + ')').length > 0) {
                        $column_flex_basis.push($last_column_block.find('>:nth-child(' + i + ')').attr('style'));

                        if(!column_with_content_index && !$last_column_block.find('>:nth-child(' + i + ')').is(':empty')) {
                            column_with_content_index = i;
                        }
                    }
                }

                // Build meta and further reading column
                let $column_html = '';
                $column_flex_basis.forEach(function(style, index) {
                    if(index === (column_with_content_index - 1)) {
                        const $single_post_extra_clone = wntrTheme.body.find('.single-post__extra').clone();
                        $column_html += '<div class="wp-block-column" style="' + style + '">' + $single_post_extra_clone.html() + '</div>';
                    } else {
                        $column_html += '<div class="wp-block-column" style="' + style + '"></div>';
                    }
                });

                // Append the column to the single post content
                $last_column_block.closest('.inner').after(
                    '<div class="inner">' +
                    '<div class="wp-block-columns">' +
                    $column_html +
                    '</div>' +
                    '</div>'
                );

                wntrTheme.body.find('.single-post__extra').remove();
            }

        }
    };

    $(document).ready(wntrTheme.init);
})(jQuery);